export default {
  setToken(state, value) {
    state.authToken = value;
  },

  setUser(state, value) {
    state.user = value;
  },

  setOfficeLogin(state, payload) {
    state.officeLogin = payload;
  },

  clearAuth(state) {
    state.officeLogin = false;
    state.authToken = null;
    state.user = {};
    state.agentData = null;
    state.additionalAccessData = null;
    state.currentProfile = null;
    state.access = 'demo';
  },
  setCurrentProfile(state, data) {
    state.currentProfile = data;
  },

  clearCurrentProfile(state) {
    state.currentProfile = null;
  },

  setAccess(state, payload) {
    state.access = payload;
  },

  setAgentData(state, payload) {
    state.agentData = payload;
  },

  clearAgentData(state) {
    state.agentData = null;
  },

  setAdditionalAccessData(state, payload) {
    state.additionalAccessData = payload;
  },

  clearAdditionalAccessData(state) {
    state.additionalAccessData = null;
  },

  setApplications(state, payload) {
    state.applications = payload;
  },

  setLogoutBlocked(state, payload) {
    state.isLogoutBlocked = payload;
  },
};
